// Custom React Hook for Firebase Cloud Messaging
import { useState, useEffect } from 'react';
import { requestNotificationPermission, onMessageListener } from './config';
import myAxios from '../Component/AxiosUrl';
import { toast } from 'react-toastify';

export const useFCM = () => {
  const [fcmToken, setFcmToken] = useState(null);
  const [notification, setNotification] = useState(null);
  const [isPermissionGranted, setIsPermissionGranted] = useState(false);

  // Check if permission already granted and get token (don't auto-request)
  useEffect(() => {
    const setupFCM = async () => {
      try {
        // Only get token if permission already granted (modal handles requesting)
        if ('Notification' in window && Notification.permission === 'granted') {
          const token = await requestNotificationPermission();
          if (token) {
            setFcmToken(token);
            setIsPermissionGranted(true);
            await saveFCMTokenToBackend(token);
          }
        }
      } catch (error) {
        console.error('Error setting up FCM:', error);
      }
    };

    setupFCM();
  }, []);

  // Listen for foreground messages
  useEffect(() => {
    const unsubscribe = onMessageListener((payload) => {
      console.log('Foreground notification received:', payload);
      setNotification(payload);
      // the bell's WebSocket may deliver the same notification — alert it only once
      const nid = payload.data?.notificationId;
      if (nid) {
        window.__etechShownNotifs = window.__etechShownNotifs || new Set();
        if (window.__etechShownNotifs.has(String(nid))) return;
        window.__etechShownNotifs.add(String(nid));
      }

      // Show toast notification - check both notification and data fields
      const title = payload.notification?.title || payload.data?.title || 'New notification';
      const body = payload.notification?.body || payload.data?.body || '';
      toast.info(`${title}: ${body}`, {
        position: 'top-right',
        autoClose: 5000,
      });
    });

    return () => {
      if (unsubscribe && typeof unsubscribe === 'function') {
        unsubscribe();
      }
    };
  }, []);

  // Save FCM token to backend
  const saveFCMTokenToBackend = async (token) => {
    try {
      const uid = localStorage.getItem('id');
      if (!uid) return;

      await myAxios.post('/save-fcm-token', {
        uid,
        fcmToken: token,
        deviceType: 'web',
        timestamp: new Date().toISOString()
      });

      console.log('FCM token saved to backend');
    } catch (error) {
      console.error('Error saving FCM token to backend:', error);
    }
  };

  return {
    fcmToken,
    notification,
    isPermissionGranted
  };
};
